import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const EditParticipantDialog = ({
  editIndex,
  editData,
  setEditIndex,
  handleEditChange,
  saveEdit,
  goPrev,
  goNext,
}) => {
  const { t } = useTranslation();

  if (editIndex === null) return null;

  return (
    <Dialog
      open={editIndex !== null}
      onClose={() => setEditIndex(null)}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        {t("editParticipant")} {editIndex + 1}
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label={t("name")}
            fullWidth
            value={editData.name}
            onChange={(e) => handleEditChange("name", e.target.value)}
          />

          <TextField
            label={t("maxShiftsPerPerson")}
            type="number"
            inputProps={{ min: 0 }}
            fullWidth
            value={editData.maxShiftsPerPerson}
            onChange={(e) =>
              handleEditChange(
                "maxShiftsPerPerson",
                parseInt(e.target.value, 10) || 0
              )
            }
          />

          <TextField
            label={t("minEmptyDaysBetweenShifts")}
            type="number"
            inputProps={{ min: 0 }}
            fullWidth
            value={editData.minEmptyDaysBetweenShifts}
            onChange={(e) =>
              handleEditChange(
                "minEmptyDaysBetweenShifts",
                parseInt(e.target.value, 10) || 0
              )
            }
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          flexDirection: "column",
          gap: 1,
          alignItems: "stretch",
          px: 3,
          pb: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Button variant="outlined" onClick={goPrev}>
            {t("previous")}
          </Button>
          <Button variant="outlined" onClick={goNext}>
            {t("next")}
          </Button>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <Button
            variant="contained"
            onClick={() => {
              saveEdit();
              setEditIndex(null);
            }}
          >
            {t("saveClose")}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default EditParticipantDialog;
